import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/footerLogo.svg";
import { Form, Formik } from "formik";

import { loginSchema } from "../../components/common/Validation";
import { loginInitialValues } from "../../components/constants/InitialFormValues";
import CustomField from "../../components/common/CustomField";
import CustomLabel from "../../components/common/CustomLabel";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { login, resendVerificationLink } from "../../store/actions/authSlice";
import { showAlert } from "../../store/reducers/alertReducer";
import ButtonLoader from "components/common/ButtonLoader";
import loginPageBackgroundImage from "../../assets/images/loginBg.webp";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading, brandInfo } = useSelector((state) => state.auth);

  const [initialValues, setInitialValues] = useState(loginInitialValues);
  const navigate = useNavigate();

  const [rememberMe, setRememberMe] = useState(false);

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  //   localStorage.setItem("I18N_LANGUAGE", lng);
  // };
  {
    /* <button onClick={() => changeLanguage("en")}>English</button>
  <button onClick={() => changeLanguage("sa")}>Arabic</button> */
  }

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  const showSignUp =
    hostname === "workspace-portal.tod.com.sa" || hostname === "localhost";

  useEffect(() => {
    const rememberedEmail = Cookies.get("rememberedEmail");
    const rememberedPassword = Cookies.get("rememberedPassword");
    if (rememberedEmail || rememberedPassword) {
      setInitialValues({
        email: rememberedEmail || "",
        password: rememberedPassword || "",
      });
      setRememberMe(true);
    }
  }, []);

  const handleOnSubmit = (values, { resetForm }) => {
    if (rememberMe) {
      Cookies.set("rememberedEmail", values.email, { expires: 30 });
      Cookies.set("rememberedPassword", values.password, { expires: 30 });
    } else {
      Cookies.remove("rememberedEmail");
      Cookies.remove("rememberedPassword");
    }
    dispatch(login(values))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          navigate(`/dashboards/overview`);

          // const {
          //   hasSubscriptionEntry,
          //   emailVerifiedAt,
          //   isCompanyDetailsSaved,
          // } = data;
          // if (emailVerifiedAt == null) {
          //   try {
          //     dispatch(resendVerificationLink({ id: data._id })).then(
          //       (action) => {
          //         const { statusCode, success, message, data } =
          //           action?.payload || {};
          //         if (statusCode === 200 && success && data) {
          //           dispatch(
          //             showAlert({
          //               text: message,
          //               type: "success",
          //             })
          //           );
          //           navigate("/verification-status");
          //         }
          //       }
          //     );
          //   } catch (err) {
          //     dispatch(
          //       showAlert({
          //         type: "error",
          //         text: "Something went wrong while sending verification email.",
          //       })
          //     );
          //     console.error("Resend verification link error:", err);
          //   }
          // // } else if (!hasSubscriptionEntry) {
          // //   navigate("/plan-picker");
          // // } else if (!isCompanyDetailsSaved) {
          // //   navigate("/orgnisation-details");
          // }
          // else {
          //   navigate(`/dashboards/overview`);
          // }
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
          const { uuid } = data;
          if (uuid) {
            navigate(`/reset-new-password/${uuid}`);
          }
        }
      })
      .catch((err) => {});

    // localStorage.setItem("authUser", authUser);
    // navigate("/dashboards/overview");
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  return (
    <div
      className="login_page"
      style={{
        backgroundImage: `url(${
          brandInfo?.theme?.loginPageBGImage &&
          brandInfo.theme.loginPageBGImage.trim() !== ""
            ? brandInfo.theme.loginPageBGImage
            : loginPageBackgroundImage
        })`,
      }}
    >
      <div className="login_form g_center">
        <div className="w-100">
          {/* <img className="company_logo" src={logo} width={180} height={96} alt="Work Space Logo"/> */}
          <img
            className="company_logo"
            src={
              brandInfo?.theme?.logo && brandInfo.theme.logo.trim() !== ""
                ? brandInfo.theme.logo
                : logo
            }
            width={180}
            height={96}
            alt="Work Space Logo"
          />
          <h1>{t("Log in")}</h1>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={loginSchema}
            onSubmit={handleOnSubmit}
          >
            {({ values, setFieldValue, errors, touched }) => (
              <Form>
                <div className="form_field">
                  <CustomLabel htmlFor="email" label={t("Email")} />
                  <CustomField
                    name="email"
                    type="email"
                    placeholder={t("Email your email")}
                    touched={touched}
                    errors={errors}
                  />
                </div>
                <div className="form_field">
                  <CustomLabel htmlFor="password" label={t("Password")} />
                  <CustomField
                    name="password"
                    type="password"
                    placeholder={t("Enter your password")}
                    touched={touched}
                    errors={errors}
                  />
                </div>
                <div className="remember_div g_between">
                  <div onClick={handleRememberMeChange} className="c_p">
                    <input
                      type="checkbox"
                      className="form-check-input c_p"
                      id="customControlInline"
                      checked={rememberMe}
                      onChange={() => {}}
                    />
                    <label
                      className="form-check-label remember_me c_p"
                      htmlFor="customControlInline"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRememberMeChange(e);
                      }}
                    >
                      {t("Remember me")}
                    </label>
                  </div>
                  <Link to="/reset-password" className="reset_password">
                    {t("Forgot Password?")}
                  </Link>
                </div>
                <button
                  type="submit"
                  className="primary_btn w-100  g_center gap-2"
                  disabled={isLoading}
                >
                  {t("Login")}
                  {isLoading && <ButtonLoader />}
                </button>
              </Form>
            )}
          </Formik>
          {/* {showSignUp && (
            <div className="text-center sign_up_link_wrapper">
              <p>Or </p>
              <Link to="/sign-up" className="sign_up_link">
                Sign up
              </Link>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Login;
